export default __webpack_public_path__ + "static/media/small.cf3ac912.jpg";